function isObject(o: any): boolean {
	return Object.prototype.toString.call(o) === '[object Object]';
}

export function isPlainObject<K extends keyof any = any, V = any>(obj: any): obj is Record<K, V> {
	if (!isObject(obj)) {
		return false;
	}

	const constructor = obj.constructor;
	if (constructor === undefined) {
		return true;
	}

	const prototype = constructor.prototype;
	if (!isObject(prototype)) {
		return false;
	}

	return prototype.hasOwnProperty('isPrototypeOf');
}
